const waffledata = [
    {
        "id": "men",
        "label": "men",
        "value": 21.729941174341345,
        "color": "#468df3"
    },
    {
        "id": "women",
        "label": "women",
        "value": 27.62986060433294,
        "color": "#ba72ff"
    },
    {
        "id": "children",
        "label": "children",
        "value": 24.966702184079217,
        "color": "#a1cfff"
    }
]
export default waffledata;